import {Pipe, PipeTransform} from '@angular/core';
import {ActiviteitType} from './activiteit';

@Pipe({
    name: 'zahActiviteitTypeIcon',
    standalone: false
})
export class ActiviteitTypeIconPipe implements PipeTransform {
  transform(activiteitType: ActiviteitType): string {
    if (activiteitType === ActiviteitType.CLIENT_MELDING) {
      return 'contact_mail';
    } else if (activiteitType === ActiviteitType.SIGNAALKAART) {
      return 'assignment';
    }
  }
}
